import React, { useState } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useLoadScript,
} from "@react-google-maps/api";
import CONFIG from "../../constant/config";
import useGeolocation from "../../hooks/useGeoLocation";

const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;

const SIZE = 20;

const libraries: any[] = ["places", "geometry"];

const MapWithMarker = (props: any) => {
  const { location: loc } = useGeolocation();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: CONFIG.GOOGLE_MAP_KEY,
    libraries,
  });

  const [popupInfo, setPopupInfo] = useState<any>(null);

  if (loadError) return <div>Error loading map</div>;
  if (!isLoaded) return <div>Loading map...</div>;

  let arr: any[] = [];
  let lat: number = 0;
  let lng: number = 0;

  if (Object.values(props) && Object.values(props)?.length > 0) {
    Object.values(props)?.forEach((item: any) => {
      if (
        item?.CentreLat !== "" &&
        item?.CentreLat !== null &&
        item?.CentreLng !== "" &&
        item?.CentreLng !== null
      ) {
        arr.push(item);
        lat += parseFloat(item?.CentreLat);
        lng += parseFloat(item?.CentreLng);
      }
    });
  }
  const calculateCenter = {
    lat: lat / arr.length || 22.72986,
    lng: lng / arr.length || 75.89813,
  };
  return (
    <div>
      <p
        style={{
          color: "red",
          marginBottom: "10px",
          fontSize: "12px",
          fontWeight: "600",
        }}
      >
        {!loc?.lat && "Allow location to see map properly"}
      </p>
      <GoogleMap
        mapContainerStyle={{
          height: "100%",
          maxHeight: "700px",
          minHeight: "500px",
        }}
        zoom={10}
        center={calculateCenter}
        options={{
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      >
        {arr.map((marker, i) => (
          <Marker
            key={i}
            position={{
              lat: parseFloat(marker?.CentreLat),
              lng: parseFloat(marker?.CentreLng),
            }}
            onClick={() =>
              setPopupInfo({
                info: marker,
                lat: parseFloat(marker?.CentreLat),
                long: parseFloat(marker?.CentreLng),
              })
            }
          >
            {popupInfo && marker?.CentreLat == popupInfo?.lat && (
              <InfoWindow onCloseClick={() => setPopupInfo(null)}>
                <div
                  style={{
                    fontSize: "16px",
                    padding: "5px",
                    fontWeight: 400,
                    maxWidth: "300px",
                  }}
                >
                  <h6>{popupInfo?.info?.CentreName}</h6>
                  <div
                    style={{
                      fontSize: "16px",
                      padding: "5px",
                      fontWeight: 400,
                      textAlign: "left",
                    }}
                  >
                    {popupInfo?.info?.AddressLine1
                      ? popupInfo?.info?.AddressLine1 + ", "
                      : ""}
                    {popupInfo?.info?.AddressLine2
                      ? popupInfo?.info?.AddressLine2 + ", "
                      : ""}
                    {popupInfo?.info?.Locality
                      ? popupInfo?.info?.Locality + ", "
                      : ""}
                    {popupInfo?.info?.CityName
                      ? popupInfo?.info?.CityName + ", "
                      : ""}
                    {popupInfo?.info?.Pincode
                      ? popupInfo?.info?.Pincode + "- "
                      : ""}
                    {popupInfo?.info?.StateName
                      ? popupInfo?.info?.StateName
                      : ""}
                  </div>
                </div>
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    </div>
  );
};

export default MapWithMarker;
/* import { useState } from "react";
import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";
import { compose, withHandlers, withProps } from "recompose";

const ICON = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;

const SIZE = 20;
const MapWithMarker = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyCUMVJzwgpyE-hqQubtSKolVELRdYJcnJ0&v=3&libraries=geometry,places",
    loadingElement: <div style={{ height: `100%`, maxHeight: "700px", minHeight: "500px" }} />,
    containerElement: <div style={{ height: `100%`, maxHeight: "700px", minHeight: "500px" }} />,
    mapElement: <div style={{ height: `100%`, maxHeight: "700px", minHeight: "500px" }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props: any) => {
  const [popupInfo, setPopupInfo] = useState<any>("");
  let arr: any[] = [];
  let lat: number = 0;
  let lng: number = 0;
  if (Object.values(props) && Object.values(props)?.length > 0) {
    Object.values(props)?.map((item: any) => {
      if (item?.CentreLat !== "" && item?.CentreLat !== null && item?.CentreLng !== "" && item?.CentreLng !== null) {
        arr.push(item);
        lat += parseFloat(item?.CentreLat);
        lng += parseFloat(item?.CentreLng);
      }
    });
  }
  const calculateCenter = { lat: lat / arr.length || 22.72986, lng: lng / arr.length || 75.89813 };
  const center = { lat: 28.7041, lng: 77.1025 };
  return (
    <GoogleMap defaultZoom={10} defaultCenter={center}>
      {Object.keys(props) &&
        Object.values(props)?.map((item: any, i: any) => {
          let marker = item;
          return (
            <>
              <Marker
                key={i}
                position={{ lat: parseFloat(marker?.CentreLat), lng: parseFloat(marker?.CentreLng) }}
                onClick={(e: any) => {
                  setPopupInfo({
                    info: marker,
                    lat: parseFloat(marker?.CentreLat),
                    long: parseFloat(marker?.CentreLng),
                  });
                }}
              >
                <svg
                  key={i}
                  height={SIZE}
                  viewBox="0 0 24 24"
                  style={{
                    cursor: "pointer",
                    fill: "#d00",
                    stroke: "none",
                    transform: `translate(${-SIZE / 2}px,${-SIZE}px)`,
                  }}
                />
                {popupInfo && marker?.CentreLat == popupInfo?.lat && (
                  <InfoWindow key={i} onCloseClick={() => setPopupInfo({})}>
                    <div style={{ fontSize: "16px", padding: "5px", fontWeight: 400, maxWidth: "300px" }}>
                      <h6>{popupInfo?.info?.CentreName}</h6>
                      <div style={{ fontSize: "16px", padding: "5px", fontWeight: 400, textAlign: "left" }}>
                        {popupInfo?.info?.AddressLine1 ? popupInfo?.info?.AddressLine1 + ", " : ""}
                        {popupInfo?.info?.AddressLine2 ? popupInfo?.info?.AddressLine2 + ", " : ""}
                        {popupInfo?.info?.Locality ? popupInfo?.info?.Locality + ", " : ""}
                        {popupInfo?.info?.Locality ? popupInfo?.info?.Locality + ", " : ""}
                        {popupInfo?.info?.CityName ? popupInfo?.info?.CityName + ", " : ""}
                        {popupInfo?.info?.Pincode ? popupInfo?.info?.Pincode + "- " : ""}
                        {popupInfo?.info?.StateName ? popupInfo?.info?.StateName : ""}
                      </div>
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            </>
          );
        })}
    </GoogleMap>
  );
});
export default MapWithMarker;
 */
